import { contentManagement } from './reducers';
export default contentManagement;
